export default "__VITE_ASSET__96843b6b__"